<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="count">
                <div class=" num" v-if="user_info.id"><div class="icon">您目前已累计：<i>{{user_info.score}}</i>积分</div></div>
                <div class=" num" v-else="!user_info.id"><div class="icon">登录后查看您的积分</div></div>
                <div class=" link">
                    <div class="center">
                        <div class="left item" @click="toHash('good')">兑换好礼</div>
                        <div class="left item" @click="toHash('description')">积分说明</div>
                        <div class="left item" @click="toggleScoreDetail">积分明细</div>
                    </div>
                </div>
            </div>
            <div class="rule" id="rule">
                <div class="title">积分累计规则</div>
                <div class="line"></div>
                <div class="list">
                    <div class="item" v-for="item in rule">
                        <div class="icon"><div class="middle">{{item.title}}</div></div>
                        <div class="num-box">
                            <div class="cen">
                                <div class="num">+{{item.number}}</div>
                                <div class="text">积分</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="good" id="good">
                <div class="title">兑换好礼</div>
                <div class="line"></div>
                <div class="list">
                    <div class="swiper-container" id="s1">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide item" v-for="(item,index) in good_list">
                                <div class="image" :style="{backgroundImage:'url('+util.autoImage(item.image)+')'}"></div>
                                <div class="info">
                                    <div class="element tit">{{item.title}}</div>
                                    <div class="score">
                                        <div class="num">{{item.integral}}</div>
                                        <div class="tt">积分</div>
                                    </div>
                                    <div class="btn">
                                        <div class="text">
                                            <div class="tt">礼品兑换</div>
                                            <div class="num">(剩余 {{item.number}}/{{item.count}})</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
            </div>
            <div class="description" id="description">
                <div class="title">积分规则</div>
                <div class="line"></div>
				<div class="list">
					<div class="item">
						<div class="tit">1、积分获取</div>
						<div class="answer">
							<p>用户首次注册成功，将获取500积分</p>
							<p>用户每观看直播30分钟，将获取500积分</p>
							<p>用户在直播中，参与直播互动回答，将获取500积分</p>
							<p>用户在直播中，进行留言互动，将获取500积分</p>
							<p>用户首次参观每个合作伙伴区域满10分钟，将获取500积分</p>
							<p>用户首次完成调查问卷，将获取500积分</p>
						</div>
					</div>
					<div class="item">
						<div class="tit">2、积分使用</div>
						<div class="answer">
							<p>积分专属2020戴尔科技峰会,仅限峰会期间使用</p>
							<p>积分可以累积，3个月内有效</p>
							<p>您可在互动专区 - 积分商城 - 积分兑好礼板块进行积分兑换</p>
						</div>
					</div>
					<div class="item">
						<div class="tit">3、积分有效期</div>
						<div class="answer">
							<p>积分自活动开始日起3个月内有效,逾期自动失效</p>
						</div>
					</div>
					<div class="item">
						<div class="tit">4、积分到账时间</div>
						<div class="answer">
							<p>根据累计规则完成互动30分钟内，点击右上角登录名，即可查看已获得的积分</p>
						</div>
					</div>
					<div class="item">
						<div class="tit">5、积分查询</div>
						<div class="answer">
							<p>请谨慎兑换积分，积分一经兑换，不能退还</p>
						</div>
					</div>
					<div class="item">
						<div class="tit">6、免责条款</div>
						<div class="answer">
							<p>积分不可兑现、不可转让,仅可在2020戴尔科技峰会活动期间使用</p>
							<p>活动主办方戴尔有权在未向您通知的情况下自行变更、终止全部或部分积分规则,戴尔无须为积分规则的变更或终止承担任何责任</p>
							<p>无论您的账户因何种原因被关闭,您的积分将自动丧失,戴尔无须为您的积分损失承担任何责任</p>
							<p>积分规则以2020戴尔科技峰会公布的最新版本为准,最终解释权由戴尔所有</p>
						</div>
					</div>
				</div>
                <div class="tip">戴尔始终致力于遵守所有可适用的法律、法规、政策以及道德准则。通过接受我们的邀请并出席本次活动，戴尔始终，加快5G网络、加快推进国家规划已明确的重大工程和基础设施建设</div>
            </div>
        </div>
        <score-detail v-if="show_score_detail" @toggleScoreDetail="toggleScoreDetail"></score-detail>
    </main>
</template>

<script>
    import Crumbs from "../../components/m/Crumbs";
    import ScoreDetail from "../../components/m/ScoreDetail";

    export default {
        name: 'score',
        data() {
            return {
                query:"",
                swiper_1:"",
                good_list:[],
				rule:[],
                show_score_detail:false,
                adv:[],
            }
        },
        components:{
            Crumbs,ScoreDetail
        },
        computed:{
            crumbs() {
                return {title:"积分商城",min_title:"Score Shop"}
            },
            user_info(){
                return this.$store.state.user_info
            }
        },
        methods: {
            swiperInit(){
                this.swiper_1 = new Swiper('#s1',{
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    spaceBetween:10,
                    observer:true,
                    observeParents:true,
                    pagination: {
                        el: '#s1 .swiper-pagination',
                        dynamicBullets: true,
                    },
                });
            },
            toggleScoreDetail(){
                if(!this.user_info.id){
                    this.util.showAuth({
                        show:true
                    });
                }else{
                    this.show_score_detail = !this.show_score_detail
                }
            },
            toHash(id){
                document.getElementById(id).scrollIntoView(true);
            },
            getScoreGood(){
                this.http.request({
                    api:"score/getScoreGood",
                    success:(res)=>{
                        this.good_list = res.list;
                        this.$nextTick(()=>{
                            this.swiperInit();
                        })
                    }
                })
            },
            getAdv(){
                this.http.request({
                    api:"adv/getAdv",
                    data:{
                        position:12,
                    },
                    success:(res)=>{
                        this.adv = res.adv;
                        this.$nextTick(()=>{
                            this.util.showBottom(true);
                        })
                    }
                })
            },
            getUserInfo(){
                if(!this.util.getAccessToken()){
                    return false;
                }
                this.http.request({
                    api:'user/getUserInfo',
                    loading:true,
                    success:(res)=>{
                        this.$store.commit('setUserInfo',res.user);
                        this.util.setDellCookie();
                    }
                })
            },
			getScoreRule(){
				this.http.request({
					api:"score/getScoreRule",
					success:(res)=>{
						this.rule = res.list;
					}
				})
			},
        },
        mounted() {
            this.query = this.$route.query;
            this.getUserInfo();
            this.getScoreRule();
            this.getScoreGood();
            this.getAdv();
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{background: #f6f6f6;padding-top: .25rem;
        .count{width:7rem;height:2.2rem;margin: 0 auto; background: url("~@/assets/image/28.png") no-repeat center center;background-size:cover;border-radius: .05rem;color:#fff;overflow: hidden;
            .num{height:1.5rem;width: 7rem; line-height: 1.5rem;font-size:.28rem;text-align: center;
                .icon{display: inline-block;padding-left: 1rem; background: url("~@/assets/image/29.png") no-repeat left center;background-size: .9rem;
                    i{font-weight: bold;font-size:.28rem;}
                }
            }
            .link{height:.7rem;line-height:.7rem;background: #256098;text-align: center;
                .center{display: inline-block;
                    .item{padding: 0 .25rem;height:.5rem;line-height: .55rem;border-radius: .25rem;margin-right: .6rem;font-size: .22rem;color:#fff;background: #3176c8;margin-top: .1rem;}
                    .item:nth-last-child(1){margin-right: 0;}
                }
            }
        }
        .rule{margin-top:.5rem;
            .title{font-size:.32rem;text-align: center;}
            .line{width:1.6rem;height:.06rem;margin: .05rem auto 0; background:#3176c8;}
            .list{overflow: hidden;margin: .3rem auto 0;padding: 0 .25rem;
                .item{width:3.4rem;height:1.6rem;float: left;margin-right:.2rem;margin-bottom: .2rem;border-radius:.05rem;overflow: hidden;background: #fff;box-shadow: 0 0 .1rem .02rem rgba(0,0,0,.1);
                    .icon{height:1.1rem;color: #fff;
                        .middle{height:1.1rem;width:3.4rem;padding: 0 .2rem; font-size:.26rem;line-height: .34rem;text-align: center;}
                    }
                    .num-box{height: .5rem;line-height:.5rem;text-align: center;
                        .cen{display: inline-block;
                            .num{float: left; font-size: .28rem;color:#0176ce;}
                            .text{float: left;font-size: .22rem;color:#929292;margin-left: .05rem;}
                        }
                    }
                }
                .item:nth-child(2n){margin-right: 0;
                    .icon{background: url("~@/assets/image/32.png") no-repeat center center;background-size: cover;}
                }
                .item:nth-child(2n+1){
                    .icon{background: url("~@/assets/image/31.png") no-repeat center center;background-size: cover;}
                }
            }
        }
        .good{padding-top: .3rem;
            .title{font-size:.32rem;text-align: center;}
            .line{width:1.6rem;height:.06rem;margin: .05rem auto 0; background:#3176c8;}
            .list{overflow: hidden;padding: .25rem;
                .swiper-container{height:9.1rem;
                    .item{height:4.1rem; border-radius:.05rem;background: #fff;position: relative;cursor: pointer;padding-top: .2rem;
                        .image{height:2rem;color: #fff;background-repeat: no-repeat;background-position: center center; background-size: contain;}
                        .info{padding:.2rem;background: #fbfbfb;margin-top: .2rem;
                            .tit{font-size: .28rem;}
                            .score{color: #0176ce;margin-top:.1rem;height:.5rem;line-height:.5rem;
                                .num{float: left; font-size:.28rem;font-weight: bold;}
                                .tt{float: left;margin-left:.05rem; font-size:.22rem;}
                            }
                            .btn{height:.6rem;padding: 0 .1rem;  border-radius:.05rem;margin-top: .1rem;line-height: .6rem;text-align: center;background: #3176c8;
                                .text{display: inline-block;color: #fff;
                                    .tt{float: left; font-size:.22rem;}
                                    .num{float: left;font-size: .18rem;margin-left:.05rem;line-height: .65rem;}
                                }
                            }
                        }
                    }
                }
            }
        }
        .description{background: #fff;padding-bottom: .5rem;padding-top: .5rem;
            .title{font-size:.32rem;text-align: center;}
            .line{width:1.6rem;height:.06rem;margin: .05rem auto 0; background:#3176c8;}
            .list{padding: 0 .25rem;
                .item{margin-top:.2rem;
                    .tit{height:.6rem;line-height:.6rem;padding-left:.2rem;font-size:.28rem;color:#0176ce;background: #f0f9fd;}
                    .answer{padding:.15rem 0 .15rem .6rem;font-size:.22rem;color:#565656;line-height: .36rem;white-space: pre-line;}
                }
            }
            .tip{padding: 0 .25rem 0 .8rem; margin: 0 auto; font-size:.2rem;color:#929292;line-height:.32rem;display: none;}
        }
    }
</style>

